import { NavLink } from "react-router-dom";
import { Icons } from "@/lib/icons";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/dashboard", label: "Home", icon: Icons.dashboard, auth: true },
  { to: "/chat", label: "Claira", icon: Icons.chat, auth: true },
  { to: "/journal", label: "Journal", icon: Icons.journal, auth: true },
  { to: "/screenings", label: "Screen", icon: Icons.screenings, auth: false },
  { to: "/support", label: "Help", icon: Icons.info, auth: false },
];

/** iOS-style bottom tab bar. Rendered only when body.platform-native is set (see CSS). */
export function MobileTabBar() {
  const { user } = useAuth();
  const tabs = TABS.filter((t) => !t.auth || user);

  async function tap() {
    try {
      const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (_) { /* web */ }
  }

  return (
    <nav
      aria-label="Primary"
      className="native-tabbar fixed inset-x-0 bottom-0 z-50 hidden border-t border-border/60 bg-background/85 backdrop-blur-xl safe-bottom safe-left safe-right"
    >
      <ul className="flex items-stretch justify-around px-2 pt-1.5 pb-1">
        {tabs.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              onClick={tap}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1.5 text-[11px] font-medium transition-colors",
                  isActive ? "text-primary" : "text-muted-foreground"
                )
              }
            >
              {({ isActive }) => (
                <>
                  <t.icon className={cn("h-[22px] w-[22px]", isActive && "drop-shadow")} strokeWidth={isActive ? 2.4 : 1.8} />
                  <span>{t.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}